export type ObjectValues<TObject> = TObject[keyof TObject]

export function objectValues<TObject extends object>(data: TObject) {
  return Object.values(data) as ObjectValues<TObject>[]
}

export async function sleep(timeout: number) {
  return new Promise((res) => {
    setTimeout(res, timeout)
  })
}

export function nonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined
}
